import styled from 'styled-components';

import BiddingSection from './component';

const StyledSection = styled(BiddingSection)`
  position: fixed;
  top: 56px;
  bottom: 0;
  right: 0;
  background-color: var(--grey800);
  width: 420px;
  padding-left: 40px;
  z-index: 999;

  .toolbar {
    color: #fff;
    background-color: var(--grey900);
    width: 40px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;

    .close {
      color: #fff;
      width: 40px;
      height: 40px;
      background-color: var(--grey900);
      border: 0;
      cursor: pointer;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        pointer-events: none;
        fill: var(--grey500) !important;
      }
      -webkit-appearance: none;
    }
  }

  .header {
    background-color: var(--grey900);
    padding: 0 1.6rem;
    font-size: 1.4rem;
    height: 40px;
    color: #fff;
    display: flex;
    align-items: center;
    text-transform: uppercase;
  }
`;

export default StyledSection;
